import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import AttorneyServicePage from "./pages/AttorneyServicePage";
import PlaceOrderPage from "./pages/PlaceOrderPage";
import ServiceAreasPage from "./pages/ServiceAreasPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ProcessServingPage from "./pages/ProcessServingPage";
import EmailTestPage from "./pages/EmailTestPage";
import CourtFilingPage from "./pages/CourtFilingPage";
import DocumentRetrievalPage from "./pages/DocumentRetrievalPage";
import SkipTracingPage from "./pages/SkipTracingPage";
import CountyRecordingPage from "./pages/CountyRecordingPage";
import HelpPage from "./pages/HelpPage";
import PrivacyPage from "./pages/PrivacyPage";
import EulaPage from "./pages/EulaPage";
import QuotePage from "./pages/QuotePage";
import StatusPage from "./pages/StatusPage";
import InboxPage from "./pages/InboxPage";
import PortalPage, { ResetPasswordPage, PaymentResultPage } from "./pages/PortalPage";
import AssistantPage from "./pages/AssistantPage";
// Resource Pages / Pillar Content
import ProcessServingGuide from "./pages/ProcessServingGuide";
import LegalDocumentServicesGuide from "./pages/LegalDocumentServicesGuide";
import CaliforniaCourtProceduresGuide from "./pages/CaliforniaCourtProceduresGuide";
// City Pages
import PalmDesertPage from "./pages/cities/PalmDesertPage";
import CathedralCityPage from "./pages/cities/CathedralCityPage";
import DesertHotSpringsPage from "./pages/cities/DesertHotSpringsPage";
import PalmSpringsPage from "./pages/cities/PalmSpringsPage";
import IndioPage from "./pages/cities/IndioPage";
import CoachellaPage from "./pages/cities/CoachellaPage";
import LaQuintaPage from "./pages/cities/LaQuintaPage";
import RanchoMiragePage from "./pages/cities/RanchoMiragePage";
import IndianWellsPage from "./pages/cities/IndianWellsPage";
import ThousandPalmsPage from "./pages/cities/ThousandPalmsPage";
// Hi-Desert Cities
import TwentyninePalmsPage from "./pages/cities/TwentyninePalmsPage";
import YuccaValleyPage from "./pages/cities/YuccaValleyPage";
import JoshuaTreePage from "./pages/cities/JoshuaTreePage";
import MorongoValleyPage from "./pages/cities/MorongoValleyPage";
import LandersPage from "./pages/cities/LandersPage";
// Central Riverside County Cities
import RiversidePage from "./pages/cities/RiversidePage";
import MorenoValleyPage from "./pages/cities/MorenoValleyPage";
import CoronaPage from "./pages/cities/CoronaPage";
import MenifeePage from "./pages/cities/MenifeePage";
import TemeculaPage from "./pages/cities/TemeculaPage";
import MurrietaPage from "./pages/cities/MurrietaPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/attorney-service" element={<AttorneyServicePage />} />
          <Route path="/place-order" element={<PlaceOrderPage />} />
          <Route path="/service-areas" element={<ServiceAreasPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/process-serving" element={<ProcessServingPage />} />
          <Route path="/email-test" element={<EmailTestPage />} />
          <Route path="/court-filing" element={<CourtFilingPage />} />
          <Route path="/document-retrieval" element={<DocumentRetrievalPage />} />
          <Route path="/skip-tracing" element={<SkipTracingPage />} />
          <Route path="/county-recording" element={<CountyRecordingPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/eula" element={<EulaPage />} />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/status" element={<StatusPage />} />
          <Route path="/inbox" element={<InboxPage />} />
          <Route path="/portal" element={<PortalPage />} />
          <Route path="/portal/assistant" element={<AssistantPage />} />
          <Route path="/portal/reset-password" element={<ResetPasswordPage />} />
          <Route path="/payment/success" element={<PaymentResultPage outcome="success" />} />
          <Route path="/payment/cancel" element={<PaymentResultPage outcome="cancel" />} />
          
          {/* Resource Pages / Pillar Content */}
          <Route path="/resources/process-serving-guide" element={<ProcessServingGuide />} />
          <Route path="/resources/legal-document-services-guide" element={<LegalDocumentServicesGuide />} />
          <Route path="/resources/california-court-procedures-guide" element={<CaliforniaCourtProceduresGuide />} />

          {/* Coachella Valley City Pages */}
          <Route path="/cities/palm-desert" element={<PalmDesertPage />} />
          <Route path="/cities/cathedral-city" element={<CathedralCityPage />} />
          <Route path="/cities/desert-hot-springs" element={<DesertHotSpringsPage />} />
          <Route path="/cities/palm-springs" element={<PalmSpringsPage />} />
          <Route path="/cities/indio" element={<IndioPage />} />
          <Route path="/cities/coachella" element={<CoachellaPage />} />
          <Route path="/cities/la-quinta" element={<LaQuintaPage />} />
          <Route path="/cities/rancho-mirage" element={<RanchoMiragePage />} />
          <Route path="/cities/indian-wells" element={<IndianWellsPage />} />
          <Route path="/cities/thousand-palms" element={<ThousandPalmsPage />} />
          {/* Hi-Desert City Pages */}
          <Route path="/cities/twentynine-palms" element={<TwentyninePalmsPage />} />
          <Route path="/cities/yucca-valley" element={<YuccaValleyPage />} />
          <Route path="/cities/joshua-tree" element={<JoshuaTreePage />} />
          <Route path="/cities/morongo-valley" element={<MorongoValleyPage />} />
          <Route path="/cities/landers" element={<LandersPage />} />
          {/* Central Riverside County City Pages */}
          <Route path="/cities/riverside" element={<RiversidePage />} />
          <Route path="/cities/moreno-valley" element={<MorenoValleyPage />} />
          <Route path="/cities/corona" element={<CoronaPage />} />
          <Route path="/cities/menifee" element={<MenifeePage />} />
          <Route path="/cities/temecula" element={<TemeculaPage />} />
          <Route path="/cities/murrieta" element={<MurrietaPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;